export default __webpack_public_path__ + "static/media/screen3.eb506f0f.png";